import styled, { css } from 'styled-components';

export const PanelWrapper = styled.section`
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TransitionWrapper = styled.div`
  display: flex;
`;

export const ContentToggle = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  cursor: pointer;
  opacity: 0.8;
  transition: 0.2s opacity ease-in-out;

  &:hover,
  &:focus {
    opacity: 1;
    transition: 0.2s opacity ease-in-out;
  }
`;

export const ToggleText = styled.span`
  margin-right: 10px;
`;

export const ToggleIcon = styled.div`
  width: 20px;
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;

  ${({ showContent }) =>
    showContent &&
    css`
      transform: rotate(180deg);
    `}

  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
    `}
`;

export const ViewSection = styled.section`
  margin: 0;
  margin-bottom: 40px;
  color: ${({ theme }) => theme.colors.black_9};
  font-size: 14px;
  padding: 0 20px;

  @media ${({ theme }) => theme.sizes.tablet} {
    padding: 0px 42px;
  }

  .ql-editor {
    p {
      margin: 0 0 15px;
    }
  }
`;

export const HeaderUserImage = styled.div`
  height: 36px;
  width: 36px;
  background-size: cover;
  display: flex;
  flex-shrink: 0;
  margin-right: 10px;
  background-position: 50%;
  border-radius: 50%;

  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
    `}
`;

export const HeaderUserName = styled.div``;

export const HeaderDate = styled.div`
  margin-left: 20px;
`;

export const HeaderRequestFeedback = styled.a`
  color: ${({ theme }) => theme.colors.black_9};
  display: flex;
  opacity: 0.7;
  margin-left: 10px;
  transition: 0.2s opacity ease-in-out;
  align-items: center;
  cursor: pointer;

  @media ${({ theme }) => theme.sizes.tablet} {
    margin-left: 20px;
  }

  &:hover,
  &:focus {
    opacity: 1;
    transition: 0.2s opacity ease-in-out;
  }

  ${({ src }) =>
    src &&
    css`
      &:before {
        background-size: 12px 12px;
        background-repeat: no-repeat;
        background-position: center center;
        border-radius: 11px;
        background-color: ${({ theme }) => theme.colors.black};
        content: ' ';
        width: 22px;
        height: 22px;
        background-image: url(${src});
      }
    `}
`;

export const SneakPeak = styled.div`
  background-position: 0;
  background-repeat: no-repeat;
  cursor: pointer;
  margin: 40px 20px 20px 20px;
  opacity: 0.7;
  padding-left: 25px;
  white-space: nowrap;

  &:hover,
  &:focus {
    opacity: 1;
    transition: 0.2s;
  }

  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
    `}
`;

export const FooterPanel = styled.div`
  position: sticky;
  bottom: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.black_1};
  background: ${({ theme }) => theme.colors.white};
  z-index: 2;
  margin-top: auto;
`;

export const NavigationPanel = styled.div`
  padding: 0px 30px;
  margin-top: auto;
  height: 60px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.black_7};
`;

export const QuestionWrapper = styled.div``;
